import { render } from "./ServiceCoverageModal.vue?vue&type=template&id=1f3033d6&scoped=true"
import script from "./ServiceCoverageModal.vue?vue&type=script&lang=js"
export * from "./ServiceCoverageModal.vue?vue&type=script&lang=js"

import "./ServiceCoverageModal.vue?vue&type=style&index=0&id=1f3033d6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3033d6"]])

export default __exports__